'use strict';
import 'jquery.easing';
import $ from 'jquery';
import Sticky from './Sticky';
import MyPjax from './MyPjax';
import NavButtonManager from './NavButtonManager';

$(function () {
  const sticky = new Sticky();
  const myPjax = new MyPjax();
  const navButtonManager = new NavButtonManager();
});
